var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "history-templates" },
    [
      _c(
        "el-button",
        {
          attrs: {
            size: "small",
            plain: "",
            icon: "el-icon-time",
            disabled: _vm.disabled || !_vm.templateId,
          },
          on: { click: _vm.open },
        },
        [_vm._v("从历史选择")]
      ),
      _c("span", [_vm._v("复用本人提交过的同类审批，修改后重新提交")]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择历史申请",
            visible: _vm.visible,
            width: "620px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            closed: _vm.cancel,
          },
        },
        [
          _c("p", [
            _vm._v(
              "选择后会替换当前填写内容。签名、审批结果和审批人不会复制，请核对日期、金额及附件。"
            ),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
            },
            [
              _vm.loadError && !_vm.loading
                ? _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.load(_vm.page)
                        },
                      },
                    },
                    [_vm._v("加载失败，点击重试")]
                  )
                : !_vm.loading && !_vm.records.length
                ? _c("el-empty", { attrs: { description: "暂无同类审批历史" } })
                : _vm._e(),
              _vm._l(_vm.records, function (item) {
                return _c(
                  "div",
                  { key: item.processInstanceId, staticClass: "history-row" },
                  [
                    _c("div", [
                      _c("strong", [_vm._v(_vm._s(item.name || "历史申请"))]),
                      _c("small", [
                        _vm._v(
                          _vm._s(_vm.time(item.startTime)) +
                            " · " +
                            _vm._s(_vm.status(item.status))
                        ),
                      ]),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "small",
                          loading: _vm.choosing === item.processInstanceId,
                          disabled: !!_vm.choosing,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.choose(item)
                          },
                        },
                      },
                      [_vm._v("使用此申请")]
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _vm.total > 20
            ? _c("el-pagination", {
                attrs: {
                  layout: "prev, pager, next",
                  "page-size": 20,
                  total: _vm.total,
                  "current-page": _vm.page,
                },
                on: { "current-change": _vm.load },
              })
            : _vm._e(),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }